// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPlusSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PPlusSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PPlusSquareOutlined = function PPlusSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPlusSquareOutlinedSvg
  }));
};

PPlusSquareOutlined.displayName = 'PPlusSquareOutlined';
export default React.forwardRef(PPlusSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPlusSquareOutlined.js
// module id = 3543
// module chunks = 0